import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9605b920"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flow-path flex-center rel"
}
const _hoisted_2 = { class: "flow-path-item" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "index" }, "1", -1))
const _hoisted_4 = { class: "text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/arrow.png",
  alt: "",
  class: "arrow"
}, null, -1))
const _hoisted_6 = { class: "flow-path-item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "index" }, "2", -1))
const _hoisted_8 = { class: "text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/arrow.png",
  alt: "",
  class: "arrow"
}, null, -1))
const _hoisted_10 = { class: "flow-path-item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "index" }, "3", -1))
const _hoisted_12 = { class: "text" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://static-s.theckb.com/BusinessMarket/Client/associated/arrow.png",
  alt: "",
  class: "arrow"
}, null, -1))
const _hoisted_14 = { class: "flow-path-item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "index" }, "4", -1))
const _hoisted_16 = { class: "text" }

import { t } from '@/plugins/i18n'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { onMounted, ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const [getValue, setValue] = useUserConfig(ENUM_CONFIG_CODE.API_ASSOCIATED_FLOW)
const isShow = ref(false)
onMounted(async () => {
  isShow.value = await getValue() !== '1'
})
const close = async () => {
  setValue('1')
  isShow.value = !await getValue()
}

return (_ctx: any,_cache: any) => {
  return (isShow.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('选择外部销售商品')), 1)
        ]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('选择供货商品')), 1)
        ]),
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('选择关联的规格')), 1)
        ]),
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("span", _hoisted_16, _toDisplayString(_unref(t)('保存即关联成功')), 1)
        ]),
        _createElementVNode("img", {
          src: "https://static-s.theckb.com/BusinessMarket/Client/associated/close.png",
          alt: "",
          class: "close",
          onClick: close
        })
      ]))
    : _createCommentVNode("", true)
}
}

})